import { ChangeDetectionStrategy, Component } from '@angular/core'

import { CardFileDownload, ImageOptions } from 'app/core/cms/generated/api-types'
import { AnchorCardComponent } from 'app/shared/anchor-card/anchor-card.component'
import { explicitComputed } from 'app/utils/signal-utils'

import { CmsBlock } from '../../cms-block'

@Component({
  selector: 'pai-card-file-download',
  templateUrl: './card-file-download.component.html',
  styleUrls: ['./card-file-download.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AnchorCardComponent],
  providers: [{ provide: CmsBlock, useExisting: CardFileDownloadComponent }],
})
export class CardFileDownloadComponent extends CmsBlock<CardFileDownload> {
  readonly __typename = 'CardFileDownload'
  protected imageOptions: ImageOptions = {
    objectFit: 'cover',
    ratio: '_5_3',
  }
  protected fileName = explicitComputed(this.data, ({ file }) => file?.filename?.replace(/^.+\//, '') ?? null)
}
